module.exports = {
	"id": "YE",
	"name": "Yemen",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.00614,
			"6": 0.01228,
			"7": null,
			"8": 0.01535,
			"9": null,
			"10": 0.00921,
			"11": 0.13508,
			"12": 0.00921,
			"13": 0.01535,
			"14": 0.02149,
			"15": 0.01535,
			"16": 0.00614,
			"17": 0.03991,
			"18": 0.03991,
			"19": 0.01228,
			"20": 0.01228,
			"21": 0.00307,
			"22": 0.13815,
			"23": 0.05833,
			"24": 0.03377,
			"25": 0.03377,
			"26": 0.02763,
			"27": 0.04298,
			"28": 0.03991,
			"29": 0.02149,
			"30": 0.11359,
			"31": 0.35305,
			"32": 0.16578,
			"33": 0.33463,
			"34": 0.0614,
			"35": 0.04605,
			"36": 0.08596,
			"37": 0.06447,
			"38": 0.0921,
			"39": 0.31314,
			"40": 0.14122,
			"41": 0.17192,
			"42": 0.07061,
			"43": 0.31007,
			"44": 0.14122,
			"45": 0.22104,
			"46": 0.20876,
			"47": 0.31314,
			"48": 0.26095,
			"49": 1.26177,
			"50": 0.22411,
			"51": 0.54339,
			"52": 0.43901,
			"53": 7.65965,
			"54": 2.03848,
			"55": 0.02149,
			"56": 0.00307,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.02456,
			"4": 0.00921,
			"5": 0.00614,
			"6": 0.04298,
			"7": null,
			"8": 0.00614,
			"9": 0.01228,
			"10": 0.01535,
			"11": 0.01842,
			"12": 0.05833,
			"13": 0.03991,
			"14": 0.00921,
			"15": 0.03991,
			"16": 0.05526,
			"17": 0.02456,
			"18": 0.0307,
			"19": 0.07368,
			"20": 0.01842,
			"21": 0.11052,
			"22": 0.03377,
			"23": 0.04298,
			"24": 0.0614,
			"25": 0.05833,
			"26": 0.14429,
			"27": 0.10131,
			"28": 0.02456,
			"29": 0.1228,
			"30": 0.11666,
			"31": 0.0921,
			"32": 0.09517,
			"33": 0.10745,
			"34": 0.10745,
			"35": 0.13508,
			"36": 0.23639,
			"37": 0.05833,
			"38": 0.0614,
			"39": 0.17499,
			"40": 0.30393,
			"41": 0.17499,
			"42": 0.13201,
			"43": 0.90258,
			"44": 0.31314,
			"45": 0.38375,
			"46": 0.18727,
			"47": 0.77364,
			"48": 0.80741,
			"49": 2.52661,
			"50": 0.07675,
			"51": 0.00614,
			"52": null,
			"3.5": 0.00921,
			"3.6": 0.02149
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.00921,
			"19": null,
			"20": 0.00614,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.00921,
			"26": null,
			"27": 0.00307,
			"28": 0.00614,
			"29": 0.04605,
			"30": 0.01842,
			"31": 0.03991,
			"32": 0.00921,
			"33": 0.03991,
			"34": 0.05219,
			"35": 0.03377,
			"36": 0.01535,
			"37": 0.1535,
			"38": 0.02763,
			"39": 0.07061,
			"40": 0.07368,
			"41": 0.00921,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.00307,
			"5": 0.01842,
			"6": null,
			"7": 0.00921,
			"8": 0.02763,
			"9": 0.00921,
			"10": 0.02149,
			"3.1": null,
			"3.2": null,
			"5.1": 0.02149,
			"6.1": null,
			"7.1": null,
			"9.1": 0.03377
		},
		"ios_saf": {
			"8": 0,
			"10": 3.62405532889,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.097664097627,
			"8.1-8.4": 0.180430282057,
			"9.0-9.2": 0.0860768318068,
			"9.3": 1.31322345962
		},
		"android": {
			"3": 0,
			"4": 0.368024186047,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0460030232558,
			"4.1": 1.32751581395,
			"4.2-4.3": 3.31878953488,
			"4.4": 7.6102144186,
			"4.4.3-4.4.4": 7.67593302326
		},
		"ie": {
			"6": 0.00946232876712,
			"7": 0.00315410958904,
			"8": 0.287023972603,
			"9": 0.075698630137,
			"10": 0.0820068493151,
			"11": 0.693904109589,
			"5.5": null
		},
		"op_mob": {
			"0": 0.300606101695,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00835016949153
		},
		"edge": {
			"12": 0.04912,
			"13": 0.07061,
			"14": 0.01842
		},
		"ie_mob": {
			"10": 0.0245966197183,
			"11": 0.100143380282
		},
		"bb": {
			"7": 0.0190575,
			"10": null
		},
		"samsung": {
			"0": 3.38184
		},
		"and_uc": {
			"0": 5.8212
		},
		"op_mini": {
			"0": 4.05001372881
		},
		"and_chr": {
			"0": 31.58417
		},
		"and_ff": {
			"0": 0.11088
		}
	},
	"total": 98.5037975
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/YE.json
 ** module id = 684
 ** module chunks = 0
 **/